import { render, staticRenderFns } from "./share-list.vue?vue&type=template&id=2dcab458&"
import script from "./share-list.vue?vue&type=script&lang=js&"
export * from "./share-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports